/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedJobCategoriesIndexRouteImport } from './routes/_authenticated/job-categories/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedJobCategoriesCategoryIdRouteImport } from './routes/_authenticated/job-categories/$categoryId'
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from './routes/_authenticated/companies/$companyId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedJobCategoriesIndexRoute =
  AuthenticatedJobCategoriesIndexRouteImport.update({
    id: '/job-categories/',
    path: '/job-categories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobCategoriesCategoryIdRoute =
  AuthenticatedJobCategoriesCategoryIdRouteImport.update({
    id: '/job-categories/$categoryId',
    path: '/job-categories/$categoryId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/job-categories/$categoryId': typeof AuthenticatedJobCategoriesCategoryIdRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/job-categories/': typeof AuthenticatedJobCategoriesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/job-categories/$categoryId': typeof AuthenticatedJobCategoriesCategoryIdRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/job-categories': typeof AuthenticatedJobCategoriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/_authenticated/job-categories/$categoryId': typeof AuthenticatedJobCategoriesCategoryIdRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/job-categories/': typeof AuthenticatedJobCategoriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/companies/$companyId'
    | '/job-categories/$categoryId'
    | '/companies/'
    | '/dashboard/'
    | '/job-categories/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/companies/$companyId'
    | '/job-categories/$categoryId'
    | '/companies'
    | '/dashboard'
    | '/job-categories'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/companies/$companyId'
    | '/_authenticated/job-categories/$categoryId'
    | '/_authenticated/companies/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/job-categories/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/job-categories/': {
      id: '/_authenticated/job-categories/'
      path: '/job-categories'
      fullPath: '/job-categories/'
      preLoaderRoute: typeof AuthenticatedJobCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/job-categories/$categoryId': {
      id: '/_authenticated/job-categories/$categoryId'
      path: '/job-categories/$categoryId'
      fullPath: '/job-categories/$categoryId'
      preLoaderRoute: typeof AuthenticatedJobCategoriesCategoryIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$companyId': {
      id: '/_authenticated/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRoute
  AuthenticatedJobCategoriesCategoryIdRoute: typeof AuthenticatedJobCategoriesCategoryIdRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedJobCategoriesIndexRoute: typeof AuthenticatedJobCategoriesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCompaniesCompanyIdRoute: AuthenticatedCompaniesCompanyIdRoute,
  AuthenticatedJobCategoriesCategoryIdRoute:
    AuthenticatedJobCategoriesCategoryIdRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedJobCategoriesIndexRoute: AuthenticatedJobCategoriesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
